export default "/imgs/banner.png"